<div class="verticals-banner-row service-banner-row">
    <div class="container h-100">
        <div class="row h-100 align-items-center">
            <div class="w-100 ms-2 me-2 ms-md-0 me-md-0">
                <h1 class="text-white">
                    <!-- <i class="fa fa-plane" aria-hidden="true"></i> -->
                    <img src="assets/images/our-services/verticals/verticals-service-icon.png" alt="ocean-service-icon" class="img-fluid service-banner-icon">
                    Verticals
                </h1>
                <!-- <div id="tabs" class="pt-3">
                    <div class="container m-w-100">
                        <div class="row">
                            <div class="col-lg-12 p-0">
                                <nav>
                                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                        <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Track Your Shipment</a>
                                        <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Online Booking</a>
                                        <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Get A Quote</a>
                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                        <form class="shipment-form">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                            <div class="form-group">
                                                <input type="text" class="form-control" id="formGroupExampleInput" 
                                                placeholder="Enter PO Number/Tracking ID/Cargo No. to get the details">
                                            </div>
                                            <button type="submit" class="btn btn-track-now">Track Now</button>
                                        </form>
                                    </div>
                                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                        <form class="shipment-form">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                            <div class="form-group">
                                                <input type="text" class="form-control" id="formGroupExampleInput" 
                                                placeholder="Enter PO Number/Tracking ID/Cargo No. to get the details">
                                            </div>
                                            <button type="submit" class="btn btn-track-now">Track Now</button>
                                        </form>
                                    </div>
                                    <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                        <form class="shipment-form">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                            <div class="form-group">
                                                <input type="text" class="form-control" id="formGroupExampleInput" 
                                                placeholder="Enter PO Number/Tracking ID/Cargo No. to get the details">
                                            </div>
                                            <button type="submit" class="btn btn-track-now">Track Now</button>
                                        </form>
                                    </div>
                                   
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div> -->
                
            </div>
        </div>
    </div>
</div>